import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Button,
  Alert,
} from '@mui/material';
import {
  Email as EmailIcon,
  OpenInNew as OpenInNewIcon,
  ContentCopy as CopyIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const steps = [
  { labelKey: 'onboarding.step1Label', descKey: 'onboarding.step1Desc', hasLink: true, linkTextKey: 'onboarding.step1Link', linkUrl: 'https://surelc.surancebay.com/sbweb/login.jsp?branchEditable=off&branchRequired=on&branchVisible=on&gaId=1201&gaName=Equity%20Partners%20(DBA%20Equity%20Insurance)', instructionsKey: 'onboarding.step1Instructions' },
  { labelKey: 'onboarding.step2Label', descKey: 'onboarding.step2Desc', hasLink: true, linkTextKey: 'onboarding.step2Link', linkUrl: 'https://form.typeform.com/to/zLXdOQsV?typeform-source=eip-portal.com' },
  { labelKey: 'onboarding.step3Label', descKey: 'onboarding.step3Desc', hasLink: false },
  { labelKey: 'onboarding.step4Label', descKey: 'onboarding.step4Desc', hasLink: false },
];

const NewAgentOnboarding = () => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="md" sx={{ py: 2 }}>
      <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
        {t('onboarding.title', 'New Agent Onboarding')}
      </Typography>
      <Typography variant="body1" sx={{ color: 'text.secondary', mb: 4 }}>
        {t('onboarding.subtitle', '4-step process to get your new agent contracted and ready to sell.')}
      </Typography>

      <Paper sx={{ p: { xs: 3, md: 4 } }}>
        <Stepper orientation="vertical" activeStep={-1}>
          {steps.map((step, index) => (
            <Step key={index} active expanded>
              <StepLabel
                StepIconProps={{
                  sx: {
                    color: 'primary.main',
                    '&.Mui-active': { color: 'primary.main' },
                    '&.Mui-completed': { color: 'primary.main' },
                  },
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  {t(step.labelKey)}
                </Typography>
              </StepLabel>
              <StepContent>
                <Typography sx={{ color: 'text.secondary', mb: step.hasLink || step.instructionsKey ? 2 : 0, fontSize: '1rem', lineHeight: 1.7 }}>
                  {t(step.descKey)}
                </Typography>
                {step.instructionsKey && (
                  <Box sx={{ bgcolor: 'action.hover', borderRadius: 2, p: 2, mb: 2 }}>
                    <Typography variant="body2" sx={{ whiteSpace: 'pre-line', lineHeight: 1.8, color: 'text.secondary' }}>
                      {t(step.instructionsKey)}
                    </Typography>
                  </Box>
                )}
                {step.hasLink && (
                  <Button
                    variant="contained"
                    size="medium"
                    endIcon={<OpenInNewIcon />}
                    href={step.linkUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ mt: 1, fontWeight: 600 }}
                  >
                    {t(step.linkTextKey)}
                  </Button>
                )}
              </StepContent>
            </Step>
          ))}
        </Stepper>
      </Paper>

      <Alert
        severity="info"
        sx={{ mt: 3, borderRadius: 2 }}
        icon={<EmailIcon />}
      >
        <Typography variant="body2">
          <strong>{t('onboarding.questionsTitle', 'Questions?')}</strong>{' '}
          {t('onboarding.questionsText', 'Reach out to')}{' '}
          <Box component="a" href="mailto:Kelly@equityinsurance.org" sx={{ color: 'primary.main', textDecoration: 'none', fontWeight: 600 }}>
            Kelly@equityinsurance.org
          </Box>{' '}
          / (724) 516-0537
        </Typography>
      </Alert>
    </Container>
  );
};

export default NewAgentOnboarding;
